module.exports = __webpack_public_path__ + "img/vila-borna-web.b3795807.png";